<template>
  <div>
    <div class="categories-container">
      <h4 class="categories-title">Categories</h4>

      <b-card-group deck class="categories-deck">
        <b-card
          title="Show All"
          :img-src="freeShowAllImg"
          img-alt="Show All"
          img-top
          class="text-center"
          @click="$emit('navigate', 'FreePerksShowAllCards'); categorySelected('ShowAll');"
        >
        </b-card>
        <b-card
          title="Expert Advice"
          :img-src="expertAdviceImg"
          img-alt="Expert Advice"
          img-top
          class="text-center"
          @click="$emit('navigate', 'FreePerksShowAllCards'); categorySelected('ExpertAdvice');"
        >
        </b-card>
        <b-card
          title="Quick Perks Courses"
          :img-src="quickPerksCoursesImg"
          img-alt="Quick Perks Courses"
          img-top
          class="text-center"
          @click="$emit('navigate', 'FreePerksShowAllCards'); categorySelected('QuickPerksCourses');"
        >
        </b-card>
        <b-card
          title="Extras"
          :img-src="extrasImg"
          img-alt="Extras"
          img-top
          class="text-center"
          @click="$emit('navigate', 'FreePerksShowAllCards'); categorySelected('Extras');"
        >
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import FreeShowAll from "@/assets/images/centre/Free/free-categories/Free-Show-All.png";
import Extras from "@/assets/images/centre/Free/free-categories/Free-extra.png";
import QuickPerksCourses from "@/assets/images/centre/Free/free-categories/Free-Quick-Perks-Courses.png";
import ExpertAdvice from "@/assets/images/centre/Free/free-categories/Free-Expert Advice.png";


export default {
  name: "FreePerksCategoriesCards",
  data() {
    return {
      freeShowAllImg: FreeShowAll,
      extrasImg: Extras,
      quickPerksCoursesImg: QuickPerksCourses,
      expertAdviceImg: ExpertAdvice,
    }
  },
  methods: {
    categorySelected(category) {
      this.$root.$emit(
        "free-category",
        category
      );
      this.$router.push({
        name: "Perks",
        query: { category: category },
    }).catch(()=>{});
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.categories-title {
  font-weight: 700;
  margin-bottom: 3rem;
}

div.card {
  border: none;
  display: inline-block;
  transition: all .2s ease-in-out;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
}

.card-img-top {
  border-radius: 50%;
  vertical-align: middle;
  background-color: $light-gray;
  width: 160px;
  height: 160px;
  filter: drop-shadow(0 0.5rem 0.25rem rgba(0, 0, 0, 0.2));
}

h4.card-title {
  font-size: 16px;
}

@media screen and (max-width: 767px) {
  div.card-deck.categories-deck {
    display: flex;

    .card {
      margin-bottom: 0;
    }

    .card-img-top {
      max-width: 100%;
      height: auto;
      padding: 0.3rem;
      background-color: transparent;

    }

    h4.card-title {
      font-size: 10px;
    }
  }
}
</style>
